/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import Cookie from 'universal-cookie';
import { downloadExcelHallazgos } from 'actions/files.actions';
import { base64toBlob } from 'utils/file';
import {
  Button,
  SelectorTipoDescarga,
  Tooltip,
  SelectTamanoPagina,
  Table,
  HeaderPage
} from 'components';
import { Form, Input, Select, Row, Col, Space, DatePicker, Checkbox, message, Spin } from 'antd';
import {
  EditOutlined,
  EyeOutlined,
  DownloadOutlined,
  CloseCircleOutlined,
  BellOutlined
} from '@ant-design/icons';
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuid } from 'uuid';
import { removeAccents } from 'utils/filters';
import { getFolioNumber, PREFIX_VIA_PUBLICA } from 'utils/getFolioNumber';
import './Monitoreos.css';
import esES from 'antd/locale/es_ES';
import { getPdfActa } from 'actions/pdf.actions';
import { cancelMonitoring } from 'actions/monitoreos.actions';
import { getMenuPermissions } from 'utils/getMenuPermissions';
import * as MensGrales from 'constants/MensajesGenerales';
import {
  NOMBRE_MENU_ESPECTACULARES,
  NOMBRE_SUBMENU_ACTAS_HALLAZGOS,
  NOMBRE_MENU_PERMISO_ELIMINAR,
  NOMBRE_MENU_PERMISO_EDITAR,
  NOMBRE_MENU_PERMISO_NOTIFICAR,
  NOMBRE_MENU_PERMISO_VALIDAR
} from 'constants/menuNombres';
import { selectMenuState } from 'selectors/auth.selector';
import { ACTA_HALLAZGO, MONITOREOS_ESPECTACULARES } from 'constants/tipoMonitoreos';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { ModalPdf, DescargaPDF } from 'components/ModalPdf/ModalPdf';
import { DOWNLOAD_TYPES } from 'constants/downloadTypes';
import InfoModal from 'components/InfoModal/InfoModal';
import { CONFIGURACION_SISTEMA } from 'constants/nombresCatalogos';
import CancelModalMonitoring from 'components/CancelModalMonitoring/CancelModalMonitoring';
import ModalNotificarPartido from 'components/ModalNotificarPartido/ModalNotificarPartido';
import {
  TIPO_HALLAZGO,
  NO_NOTIFICADO,
  NOTIFICADO,
  PARCIALMENTE_NOTIFICADO
} from 'constants/notificarPartidos';
import * as actasService from '../../services/espectacularesActas';
import ModalActa from '../MonitoreosEspectaculares/Hallazgos/ModalHallazgos';
import * as monitoreoService from '../../services/espectaculares.service';

// MNI - Genera formatos PDF al validar
import { generarPDFMonitoreosValidacion } from 'services/monitoreos.service';
import { generarPDFMonitoreos } from 'services/monitoreos.service';

import { selectCatalogs } from 'selectors/catalogos.selectors';

const { Option } = Select;
let monitoreos = [];
let catProceso = [];
let catProcesoEspesifico = [];
let catEstados = [];
let dataActa = {};
let datosgetActa = [];
let monitoreo = {
  idAmbito: '',
  idEstado: '',
  nombreEstado: '',
  idMonitoreo: '',
  idMunicipio: '',
  idProcesoElectoral: '',
  idProcesoEspecifico: '',
  estatus: '',
  hallazgo: [],
  notificacion: ''
};
let hallazgo = {
  key: '',
  idAmbito: '',
  idMunicipio: '',
  idProcesoElectoral: '',
  idDistritoLoc: '',
  idEntidad: '',
  idHallazgo: '',
  nombreEstado: '',
  tipoBeneficio: '',
  idTipoAsociacion: '',
  sujetoObligado: '',
  cargo: '',
  nombreBeneficiado: '',
  nombre: '',
  idINE: '',
  cantidad: '',
  ancho: '',
  alto: '',
  duracion: '',
  lema: '',
  infAdicional: '',
  idContabilidad: '',
  Folio: '',
  monitor: '',
  fechaNoModificada: '',
  fechainicio: '',
  tipoHallazgo: '',
  tipoBeneficcio: '',
  estatus: '',
  ubicacion: {},
  estados: [],
  tipoAsociaciones: [],
  tipoBeneficios: [],
  catProceso: [],
  catMonitoreos: [],
  cargos: [],
  catMedidas: [],
  sujetosObligados: [],
  nombreProceso: '',
  nombreAmbito: '',
  idUbicacion: '',
  idMonitoreo: '',
  idSujetoObligado: '',
  // Datos hallazgo
  tipoMedida: '',
  medida: '',
  duracionHr: '',
  duracionMin: '',
  duracionSeg: '',
  ambitoMonitoreo: '',
  idTipoHallazgo: '',
  idTipoBeneficcio: '',
  idestatus: '',
  catMedida: ''
};
let catMonitoreos = [];
const ubicacion = {
  calle: '',
  numeroExt: '',
  numeroJunta: '',
  colonia: '',
  cp: '',
  muncipio: '',
  calle1: '',
  calle2: '',
  referencias: ''
};

let tipoAsociaciones = [];
let tipoBeneficios = [];
let sujetosObligados = [];
let cargos = [];
let cathallazgo = [];
let catMedida = [];
let catUnidadesMedida = [];
let catBeneficiado = [];
let catestado = {
  id: '',
  nombre: ''
};
let catEstadosFilter = [];
const muestrasPdf = [
  {
    url: ''
  },
  {
    url: ''
  },
  {
    url: ''
  },
  {
    url: ''
  },
  {
    url: ''
  }
];
let code = '';
export function Monitoreo() {
  let listaActas = [];
  const dispatch = useDispatch();
  const [estados, setEstados] = useState([]);
  const [isModalCancel, setIsModalCancel] = useState(false);
  const { data: usuario } = useSelector((state) => state.validarUsuario);
  const menu = useSelector(selectMenuState);
  const [usuariosFiltro, setUsuariosFiltro] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [isModalPdfOpen, setIsModalPdfOpen] = useState(false);
  const [isHallazgoId, setIsHallazgoId] = useState(null);
  const [isMonitoreoId, setIsMonitoreoId] = useState(null);
  const [datosActa, setDatosActa] = useState([]);
  let listaValidarHllazgos = [];
  let listaDesvalidarHallazgos = [];
  const [messageApi, contextHolder] = message.useMessage();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [loadingTable, setLoadingTable] = useState(false);
  const [loadigBotton, setLoadingBotton] = useState(false);
  const na = 'N/A';
  const [counter, setCounter] = useState(0);
  const placement = 'topRight';
  const [locale] = useState(esES);
  const dateFormat = 'DD MMMM YYYY';
  const [registros, setValueRecords] = useState('10');
  const { data } = useSelector((state) => state.validarUsuario);
  const [searchParams, setSearchParams] = useSearchParams();
  const [actasRecibidas, setActasRecibidas] = useState(false);
  const [disableBtnVali, setDisableBtnVali] = useState(false);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const seleccion = useRef({});
  const notificar = useRef({});
  const validar = useRef({});
  const [pdfActa, setPdfActa] = useState(null);
  const [isModalPDF, setIsModalPDF] = useState(false);
  const [validarOn, setValidarOn] = useState(false);
  const [isVisibleSuccessModal, setIsVisibleSuccessModal] = useState(false);
  const [datosFiltro, setDatosFiltro] = useState([]);
  const [monitoreoCancelar, setMonitoreoCancelar] = useState(null);
  const [successCancelar, setSuccessCancelar] = useState(false);
  const [titleCancel, setTitleCancel] = useState('');
  const [checkedListDescargas, setCheckedListDescargas] = useState([]);
  const [checkedListNotificar, setCheckedListNotificar] = useState([]);
  const [checkedListValidar, setCheckedListValidar] = useState([]);
  const [disableButtonNotificar, setDisableButtonNotificar] = useState(true);
  const [visibleModalNotificar, setVisibleModalNotificar] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);

  // MNI - Procesar todos
  const [procesarTodo, setProcesarTodo] = useState(false);

  const catalogos = useSelector(selectCatalogs);

  const tienePermisoValidar = getMenuPermissions(
    menu,
    NOMBRE_MENU_ESPECTACULARES,
    NOMBRE_SUBMENU_ACTAS_HALLAZGOS,
    NOMBRE_MENU_PERMISO_VALIDAR
  );

  const tienePermisoEditar = getMenuPermissions(
    menu,
    NOMBRE_MENU_ESPECTACULARES,
    NOMBRE_SUBMENU_ACTAS_HALLAZGOS,
    NOMBRE_MENU_PERMISO_EDITAR
  );

  const configuracionSistema = useSelector(selectCatalogByName(CONFIGURACION_SISTEMA));
  const fechaIniciOper =
    configuracionSistema.find((config) => config.parametro === 'FECHA_INICIO_OPERACIONES')?.valor ||
    null;
  const dateFormatFiltro = 'YYYYMMDD';
  const fechaHoy = new Date().toISOString().slice(0, 10);

  const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
  };
  const showTotal = (total, range) => {
    return `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`;
  };

  const [pagination, setPagination] = useState({
    position: ['bottomRight'],
    showQuickJumper: true,
    size: 'small',
    pageSize: 10,
    current: 1,
    showTotal,
    total: totalRegistros,
    showSizeChanger: false
  });

  const handleChangePageSize = (pageSize) => {
    try {
      setPagination((prevPagination) => ({ ...prevPagination, pageSize, current: 1 }));
      // getActas();
      setLoading(true);
      setLoadingBotton(true);
      setLoadingTable(true);
    } catch (error) {
      console.log('Error***', error.message);
      setLoading(false);
      setLoadingBotton(true);
      setLoadingTable(false);
    }
  };

  const processRangeCheckNotificar = (startIndex, endIndex, list) => {
    if (startIndex < 0 || endIndex >= list?.length || startIndex > endIndex) {
      // console.info('Índices inválidos');
      return;
    }
    setDisableButtonNotificar(true);
    const listPage = list.slice(startIndex, endIndex);
    const checkedList = listPage.filter((hzgo) => hzgo.actaHallazgoNotificada === 1);
    // console.log('checkedList', checkedList);
    const seleccionN = {};
    if (checkedList.length > 0) {
      // setCheckedListNotificar((prevCheckedList) => [...prevCheckedList, ...checkedList]);
      setCheckedListNotificar((prevCheckedList) => {
        const uniqueSet = new Set(prevCheckedList);
        checkedList.forEach((item) => {
          seleccionN[item.idHallazgo] = true;
          uniqueSet.add(item);
        });
        notificar.current = seleccionN;
        return Array.from(uniqueSet);
      });
      setDisableButtonNotificar(false);
    }
  };

  const processRangeCheckValidar = (startIndex, endIndex, list) => {
    const listPage = list.slice(startIndex, endIndex > list.length ? list.length : endIndex);
    const checkedList = listPage.filter((hzgo) => hzgo.idestatus === 4);
    const seleccionN = {};

    if (checkedList.length > 0) {
      checkedList.forEach((item) => {
        seleccionN[item.idHallazgo] = true;
      });
      validar.current = seleccionN;
    }
  };

  async function getActas() {
    setSearchValue('asdasd');
    // const coki = new Cookie();
    listaActas = [];
    // eslint-disable-next-line no-unused-vars
    // const tokken = coki.get('JWT-TOKEN-SIMAC');
    const payload = {
      // token: tokken,
      tipoMonitoreo: MONITOREOS_ESPECTACULARES,
      tipoAcceso: 2,
      tipoActa: ACTA_HALLAZGO,
      pagina: pagination.current,
      cantidad: pagination.pageSize
    };
    // const respuesta2 = {
    //   token: tokken,
    //   tipoAcceso: 2
    // };

    // const respuestaEntidades = {
    //   token: tokken,
    //   tipoAcceso: 2,
    //   idProceso: 1
    // };

    try {
      // if (counter === 0)
      // {

      // MNI - Se comenta consulta de Catalogos generales y se obtiene de la memoria ya que se cargó al iniciar sesión.
      //const catalogos = await actasService.catalogos(respuesta2);
      catProceso = catalogos.data.procesosElectorales;
      catProcesoEspesifico = catalogos.data.procesosEspecificos;
      catEstados = catalogos.data.estados;
      tipoAsociaciones = catalogos.data.beneficiados;
      tipoBeneficios = catalogos.data.tipoBeneficio;
      catBeneficiado = catalogos.data.beneficiados;
      sujetosObligados = catalogos.data.beneficiados;
      catUnidadesMedida = catalogos.data.unidadesMedida;
      cargos = catalogos.data.candidaturas;
      cathallazgo = catalogos.data.tipoMonitoreos[0].tipoHallazgos;
      catMedida = catalogos.data.tipoMonitoreos[0].tiposMedida;
      catMonitoreos = catalogos.data.tipoMonitoreos;
      // }
      setSearchValue('');
      // console.log('getActas', payload);
      datosgetActa = await actasService.actas(payload);
      setTotalRegistros(datosgetActa.data.monitoreos.totalMonEspectaculares);
      setLoading(false);
      setCounter(counter + 1);
      const event = { target: { checked: false } };
      onCheckAllChange(event, 'Notificar');
      onCheckAllChange(event, 'Descargas');
      onCheckAllChange(event, 'Validar');
    } catch (error) {
      setLoading(false);
      console.log('Error***', error.message);
    }
  }

  monitoreos = [];
  if (counter >= 1) {
    try {
      catEstadosFilter = [];
      // eslint-disable-next-line array-callback-return
      catEstados?.map((e) => {
        const catestado = {
          id: e.idEstado,
          nombre: e.nombreEstado
        };
        catEstadosFilter.push(catestado);
      });
      const datosActas = datosgetActa.data;
      if (datosActas) {
        const monitoreoData = datosActas.monitoreos;

        // eslint-disable-next-line func-names, array-callback-return
        const modifiedArr = monitoreoData.espectaculares.map((x) => {
          monitoreo = {
            idAmbito: '',
            idEstado: '',
            idMonitoreo: '',
            idMunicipio: '',
            idProcesoElectoral: '',
            idProcesoEspecifico: '',
            hallazgo: [],
            notificacion: ''
          };
          monitoreo.idEstado = x.idEstado;
          monitoreo.catEstados = catEstados;
          monitoreo.nombreEstado = x.estado;
          monitoreo.estatus = x.estatusMonitoreo;
          monitoreo.usoVoz = x.usoVoz;
          monitoreo.recorrido = x.recorrido;
          monitoreo.sujetosObligados = sujetosObligados;
          monitoreo.idMonitoreo = x.idMonitoreo;
          monitoreo.idMunicipio = x.idMunicipio;
          monitoreo.idProcesoElectoral = x.idProcesoGral;
          monitoreo.idProcesoEspecifico = x.idTipoEleccion;
          monitoreo.usoVoz = x.usoVoz;
          monitoreo.otrosHechos = x.otrosHechos;
          monitoreo.recorrido = x.recorrido;
          monitoreo.muestrasPdf = muestrasPdf;
          // eslint-disable-next-line array-callback-return
          x.hallazgos?.map((z) => {
            hallazgo = {};
            hallazgo.muestrasPdf = muestrasPdf;
            hallazgo.key = uuid();
            hallazgo.cargos = cargos;
            hallazgo.ambitoMonitoreo = z.idAmbito;
            hallazgo.sujetosObligados = sujetosObligados;
            hallazgo.campaniaAnterior = z.campaniaAnterior;
            // Datos Hallazgo
            hallazgo.tipoMedida = z.tipoMedida;
            hallazgo.medida = z.medida;
            hallazgo.duracionHr = z.duracionHr;
            hallazgo.duracionMin = z.duracionMin;
            hallazgo.duracionSeg = z.duracionSeg;
            hallazgo.cantidad = z.cantidad;
            hallazgo.tieneActas = z.tieneActas;
            //
            hallazgo.motivoCancelacion = z.motivoCancelacion;
            hallazgo.catBeneficiado = catBeneficiado;
            hallazgo.tipoEleccion = x.tipoEleccion;
            hallazgo.idMonitoreo = x.idMonitoreo;
            hallazgo.idDistritoLoc = z.idDistritoLoc;
            hallazgo.idDistritoFed = z.idDistritoFed;
            hallazgo.idTipoMedida = z.idTipoMedida;
            hallazgo.idHallazgo = z.idHallazgo;
            hallazgo.idEntidad = x.idEstado;
            hallazgo.catMedidas = catUnidadesMedida;
            hallazgo.nombreEstado = x.estado;
            hallazgo.tipoBeneficio = z.tipoBeneficio;
            hallazgo.beneficiados = z.beneficiados;
            hallazgo.idProcesoEspecifico = z.idProcesoEspecifico;
            hallazgo.idTipoAsociacion = z.beneficiados[0]?.idTipoAsociacion;
            hallazgo.idSujetoObligado = z.beneficiados[0]?.idSujetoObligado;
            hallazgo.sujetoObligado = z.beneficiados[0]?.sujetoObligado;
            hallazgo.idContabilidad = z.beneficiados[0]?.idContabilidad;
            hallazgo.cargo = z.beneficiados[0]?.cargo;
            hallazgo.nombreBeneficiado = z.beneficiados[0]?.nombreBeneficiado;
            hallazgo.idBeneficiado = z.beneficiados[0]?.idBeneficiado;
            hallazgo.idAmbito = z.idAmbito;
            hallazgo.idMunicipio = x.idMunicipio;
            hallazgo.idProcesoElectoral = x.idProcesoGral;
            hallazgo.idINE = z.idINE;
            hallazgo.placas = z.placas;
            hallazgo.lema = z.lema;
            hallazgo.infAdicional = z.infAdicional;
            hallazgo.Folio = z.folioMonitoreo;
            hallazgo.monitor = z.monitor;
            hallazgo.ubicacion = z.ubicacion;
            const time = z.fechaCreacion;
            hallazgo.fechaNoModificada = z.fechaCreacion;
            hallazgo.estados = catEstados;
            hallazgo.tipoAsociaciones = tipoAsociaciones;
            hallazgo.tipoBeneficios = tipoBeneficios;
            hallazgo.catProceso = catProceso;
            hallazgo.catProcesoEspesifico = catProcesoEspesifico;
            hallazgo.nombreProceso = x.procesoEspecifico;
            hallazgo.nombreAmbito = x.ambito;
            hallazgo.catMonitoreos = catMonitoreos;
            // eslint-disable-next-line vars-on-top
            var fecha = new Date(
              time.replace(/^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/, '$4:$5:$6 $2/$3/$1')
            );
            hallazgo.fechainicio = dayjs(fecha).locale('es').format('DD [de] MMMM [de] YYYY HH:mm');
            if (z.idTipoHallazgo != null) {
              // eslint-disable-next-line array-callback-return
              cathallazgo.map((u) => {
                // eslint-disable-next-line eqeqeq
                if (u.idHallazgo == z.idTipoHallazgo) {
                  hallazgo.tipoHallazgo = u.nombreHallazgo;
                }
              });
            }
            hallazgo.idTipoHallazgo = z.idTipoHallazgo;
            if (z.tipoBeneficio != null) {
              // eslint-disable-next-line array-callback-return
              tipoBeneficios.map((b) => {
                // eslint-disable-next-line eqeqeq
                if (b.idTipoBeneficio == z.tipoBeneficio) {
                  hallazgo.tipoBeneficio = b.nombreTipoBeneficio;
                }
              });
            }
            hallazgo.cathallazgo = cathallazgo;
            hallazgo.catMedida = catMedida;
            hallazgo.idTipoBeneficcio = z.tipoBeneficio;
            hallazgo.estatus = z.estatus;
            hallazgo.notificacion = 'N/A';
            hallazgo.actaHallazgoNotificada = z.actaHallazgoNotificada;
            if (z.estatus === 2) {
              hallazgo.estatus = 'No validado';
              hallazgo.boolEstatus = false;
            }
            if (z.estatus === 3) {
              hallazgo.estatus = 'Cancelado';
              hallazgo.boolEstatus = false;
            }
            if (z.estatus === 4) {
              hallazgo.estatus = 'Validado';
              hallazgo.boolEstatus = true;
            }
            hallazgo.idestatus = z.estatus;
            monitoreo.hallazgo.push(hallazgo);
          });
          monitoreos.push(monitoreo);
        });
      }
    } catch (error) {
      console.log('Error*$', error);
    }
  }

  listaActas = [];
  if (monitoreos.length > 0) {
    monitoreos.map((x) => {
      // eslint-disable-next-line array-callback-return
      x.hallazgo.map((y) => {
        listaActas.push(y);
      });
      if (!actasRecibidas) {
        setActasRecibidas(true);
        processRangeCheckNotificar(0, pagination.pageSize, listaActas);
        processRangeCheckValidar(0, pagination.pageSize, listaActas);
      }

      return listaActas;
    });
  }

  const allOptions = listaActas;
  const checkAllOptionsDescargas =
    allOptions.length === checkedListDescargas.length && allOptions.length !== 0;
  const indeterminateDescargas =
    checkedListDescargas.length > 0 && checkedListDescargas.length < allOptions.length;

  const allOptionsNotificar = listaActas.filter(
    (hzgo) => hzgo.estatus === 'Validado' && hzgo.actaHallazgoNotificada !== NOTIFICADO
  );
  const notificadosParcialmente = allOptionsNotificar.filter(
    (hzgo) => hzgo.actaHallazgoNotificada === PARCIALMENTE_NOTIFICADO
  );
  const checkAllOptionsNotificar =
    allOptionsNotificar.length === checkedListNotificar.length && allOptionsNotificar.length !== 0;
  const indeterminateNotificar =
    (checkedListNotificar.length > 0 && checkedListNotificar.length < allOptionsNotificar.length) ||
    notificadosParcialmente?.length > 0;

  const allOptionsValidar = listaActas.filter((hzgo) => hzgo.idestatus === 2);
  const allOptionsValidados = listaActas.filter((hzgo) => hzgo && hzgo.idestatus === 4);
  const checkAllOptionsValidar =
    allOptionsValidar.length === checkedListValidar.length && allOptionsValidar.length !== 0;
  const indeterminateValidar =
    checkedListValidar.length > 0 && checkedListValidar.length < allOptionsValidar.length;

  const checkBoxEstatusMonitoreo = (row) => {
    // console.log('check row::', row);
    let enableCheckBox = false;
    if (
      row.estatus === 'En proceso' ||
      row.estatus === 'Cancelado' ||
      row.estatus === 'No validado' ||
      row.actaHallazgoNotificada === NOTIFICADO
    ) {
      enableCheckBox = true;
    }
    return enableCheckBox;
  };

  const onChange = (row, checked, optionType) => {
    switch (optionType) {
      case 'Descargas':
        if (checked) {
          setCheckedListDescargas((prevCheckedList) => [...prevCheckedList, row]);
        } else {
          // Si está desmarcado, filtrar el row fuera del checkedList
          setCheckedListDescargas((prevCheckedList) =>
            prevCheckedList.filter((item) => item.idHallazgo !== row.idHallazgo)
          );
        }
        break;
      case 'Notificar':
        if (checked) {
          // Verifica que row tenga un identificador único
          if (!row.idHallazgo) {
            console.error('Falta idHallazgo en el row:', row);
            return;
          }

          setCheckedListNotificar((prevCheckedList) => {
            // Evita agregar duplicados
            if (!prevCheckedList.some((item) => item.idHallazgo === row.idHallazgo)) {
              return [...prevCheckedList, row];
            }
            return prevCheckedList;
          });
        } else {
          setCheckedListNotificar((prevCheckedList) =>
            prevCheckedList.filter((item) => item.idHallazgo !== row.idHallazgo)
          );
        }
        break;

      default:
        if (checked) {
          // Si está marcado, agregar el row al checkedList
          setCheckedListValidar((prevCheckedList) => [...prevCheckedList, row]);
        } else {
          // Si está desmarcado, filtrar el row fuera del checkedList
          setCheckedListValidar((prevCheckedList) =>
            prevCheckedList.filter((item) => item.idForValidar !== row.idForValidar)
          );
        }
    }
  };

  const onCheckAllChange = (e, optionType) => {
    const newSeleccion = {};
    const newNotificar = {};
    const newValidar = {};
    switch (optionType) {
      case 'Descargas':
        if (e.target.checked) {
          allOptions.forEach((item) => {
            newSeleccion[item.idHallazgo] = true;
          });
          // eslint-disable-next-line no-param-reassign
          seleccion.current = newSeleccion;
          setProcesarTodo(true);
        } else {
          allOptions.forEach((item) => {
            newSeleccion[item.idHallazgo] = false;
          });
          // eslint-disable-next-line no-param-reassign
          seleccion.current = newSeleccion;
          setProcesarTodo(false);
        }
        setCheckedListDescargas(e.target.checked ? allOptions : []);
        break;
      case 'Notificar':
        if (e.target.checked) {
          allOptionsNotificar.forEach((item) => {
            newNotificar[item.idHallazgo] = true;
          });
          notificadosParcialmente.forEach((item) => {
            newNotificar[item.idHallazgo] = true;
          });
        } else {
          allOptionsNotificar.forEach((item) => {
            newNotificar[item.idHallazgo] = false;
          });
          notificadosParcialmente.forEach((item) => {
            newNotificar[item.idHallazgo] = false;
          });
        }
        notificar.current = newNotificar;
        setCheckedListNotificar(e.target.checked ? allOptionsNotificar : []);
        break;
      default:
        {
          const listaDatos = (listaActas.length > 0 ? listaActas : usuariosFiltro).slice(
            0,
            pagination.pageSize - 1
          );
          allOptionsValidados.forEach((item) => {
            newValidar[item.idHallazgo] = true;
          });
          if (e.target.checked) {
            allOptionsValidar.forEach((item) => {
              newValidar[item.idHallazgo] = true;
            });
            // eslint-disable-next-line no-param-reassign
            // await Promise.all(
            // listaDatos.forEach((item) => {
            //   if (item.idestatus === 2) {
            //     item.boolEstatus = true;
            //     ValidarHallazgo(item, e);
            //   }
            // });
            // );
            validar.current = newValidar;
          } else {
            allOptionsValidar.forEach((item) => {
              newValidar[item.idHallazgo] = false;
            });
            // eslint-disable-next-line no-param-reassign
            validar.current = newValidar;
            // listaDatos.forEach((item) => {
            //   if (item.idestatus === 2) {
            //     item.boolEstatus = false;
            //     ValidarHallazgo(item, e);
            //   }
            // });
            // console.log('vacia listaValidarHllazgos', listaValidarHllazgos);
            // listaValidarHllazgos = [];
          }
        }
        setCheckedListValidar(e.target.checked ? allOptionsValidar : []);
    }
  };

  const checkAll = (columnName, lblColumn) => (
    <label className="checkAll" htmlFor={columnName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateDescargas}
        onChange={(e) => onCheckAllChange(e, 'Descargas')}
        checked={checkAllOptionsDescargas}
        disabled={allOptions.length === 0}
      />
    </label>
  );

  const checkAllValidar = (columnName, lblColumn) => (
    <label className="checkAll" htmlFor={columnName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateValidar}
        onChange={(e) => onCheckAllChange(e, 'Validar')}
        checked={checkAllOptionsValidar}
        disabled={allOptionsValidar.length === 0}
      />
    </label>
  );

  const checkAllNotificar = (columName, lblColumn) => (
    <label className="checkAll" htmlFor={columName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateNotificar}
        onChange={(e) => onCheckAllChange(e, 'Notificar')}
        checked={checkAllOptionsNotificar}
        disabled={allOptionsNotificar.length === 0}
      />
    </label>
  );

  const renderCheckboxDescarga = (row) => (
    <Checkbox
      checked={!!seleccion.current[row.idHallazgo]}
      defaultChecked={seleccion.current?.[row.idHallazgo]}
      key={row.idHallazgo}
      onChange={({ target }) => {
        const { current } = seleccion;
        current[row.idHallazgo] = target.checked;
        onChange(row, target.checked, 'Descargas');
      }}
    />
  );

  const renderCheckboxNotificar = (row) => {
    // console.log('row::', row);
    if (tienePermisoEditar || tienePermisoValidar) {
      return (
        <Checkbox
          checked={
            !!notificar.current[row.idHallazgo] ||
            row.actaHallazgoNotificada === PARCIALMENTE_NOTIFICADO ||
            row.actaHallazgoNotificada === NOTIFICADO
          }
          disabled={checkBoxEstatusMonitoreo(row)}
          defaultChecked={seleccion.current?.[row.idHallazgo]}
          key={row.idHallazgo}
          onChange={({ target }) => {
            const { current } = notificar;
            current[row.idHallazgo] = target.checked;
            onChange(row, target.checked, 'Notificar');
          }}
        />
      );
    }
    return <Checkbox disabled />;
  };

  const renderCheck = (record, rol) => {
    // console.log('renderCheckValidar:', record);
    if (record.estatus === 'Cancelado') {
      return (
        // <div className="column-acciones">
        <Checkbox disabled />
        // </div>
      );
    }
    if (rol === 'SIMAC.CONSULTA.OC') {
      setDisableBtnVali(true);
    }
    // if (tienePermisoValidar && record.tieneActas) {
    return (
      <Checkbox
        // defaultChecked={record.boolEstatus}
        checked={!!validar.current[record.idHallazgo] || record.estatus === 'Validado'}
        onChange={(e) => {
          const { current } = validar;
          current[record.idHallazgo] = e.target.checked;
          onChange(record, e.target.checked, 'Validar');
        }}
        disabled={record.idestatus === 4}
      />
    );
    // }
    // return (
    //   <div className="column-acciones">
    //     <Checkbox disabled />
    //   </div>
    // );
  };

  async function getActasEstatus() {
    const coki = new Cookie();
    // eslint-disable-next-line no-unused-vars
    const tokken = coki.get('JWT-TOKEN-SIMAC');
    const respuesta = {
      token: tokken,
      tipoMonitoreo: 1,
      tipoActa: ACTA_HALLAZGO,
      pagina: pagination.current, // MNI - PAGINACION
      cantidad: pagination.pageSize // MNI - PAGINACION
    };
    try {
      datosgetActa = await actasService.actas(respuesta);
      // console.info('datosgetActa');
    } catch (error) {
      console.log('**Error', error.message);
    }
  }

  const handleChangeFolioFilter = (e) => {
    setSearchValue('');
    const currValue = e.target.value;
    const copiaUsr = [...listaActas];
    if (currValue.length > 0 && copiaUsr.length > 0) {
      setSearchValue(currValue);
      const filteredData = copiaUsr.filter((entry) =>
        entry.Folio.toString().toLowerCase().includes(currValue.toLowerCase())
      );
      setUsuariosFiltro(filteredData);
    }
  };

  useEffect(() => {
    try {
      setLoading(true);
      setLoadingBotton(true);
      setLoadingTable(true);

      getActas();
    } catch (error) {
      setLoading(false);
      setLoadingBotton(false);
      setLoadingTable(false);
    }
  }, [pagination]);

  useEffect(() => {
    try {
      if (!actasRecibidas) return;

      const folioUrl = searchParams.get('folio');
      if (!folioUrl) return;

      form.setFieldsValue({ folio: folioUrl });
      handleChangeFolioFilter({ target: { value: folioUrl } });
      setSearchParams();
    } catch (error) {
      console.error('Error: ', error);
    }
  }, [actasRecibidas, searchParams, setSearchParams]);

  const actaSeleccionar = (idHallazgo) => {
    monitoreos.forEach((monitoreoLista) => {
      monitoreoLista.hallazgo.forEach((hallazgoLista) => {
        if (hallazgoLista.idHallazgo === idHallazgo) {
          setDatosActa(hallazgoLista);
        }
      });
    });
  };

  const handleGetPdfActa = async (idHallazgo, option, idMonitoreo) => {
    // En Hallazgos la petición del servicio es con su idHallazgos
    const payload = {
      tipoMonitoreo: MONITOREOS_ESPECTACULARES,
      tipoActa: ACTA_HALLAZGO,
      tipoDescarga: DOWNLOAD_TYPES.TESTIGOS.value,
      listaIdMonitoreos: [idHallazgo]
    };
    try {
      const { success, response } = await dispatch(getPdfActa(payload));

      const { archivo } = response.data;
      if (success) {
        setPdfActa(archivo);

        if (option === 'eyeOutlined') {
          setIsModalPdfOpen(true);
          setIsHallazgoId(idHallazgo);
          setIsMonitoreoId(idMonitoreo);
        }

        if (option === 'downloadOutlined') {
          DescargaPDF(archivo, ACTA_HALLAZGO, idHallazgo, idMonitoreo);
        }
      }
    } catch (error) {
      messageApi.error('Error al obtener el PDF', 3);
    }
  };

  const limpiar = () => {
    setSearchValue('');
  };

  const getNumFromStr = (value) => {
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string') {
      value = value.replace(/\D/g, '');
      return parseInt(value, 10);
    }
    return null;
  };

  const busqueda = (datos) => {
    // listasActas son los registros de la tabla de donde se filtrará
    // filteredData es el arreglo con los registros que cumplen las condiciones
    // datos son los criterios de búsqueda
    const filteredData = [];

    for (let i = 0; i < listaActas.length; i += 1) {
      let buscado = true;
      if (datos.proceso != null && listaActas[i].idProcesoElectoral !== datos.proceso) {
        buscado = false;
      }
      if (datos.procesoEsp != null) {
        const numProcEsp = getNumFromStr(datos.procesoEsp);
        if (
          numProcEsp != null &&
          !Number.isNaN(numProcEsp) &&
          listaActas[i].idProcesoEspecifico !== numProcEsp
        ) {
          buscado = false;
        }
      }
      if (datos.idDesTemp != null) {
        const fDesde = dayjs(datos.idDesTemp).startOf('day');
        const fData = dayjs(listaActas[i].fechaNoModificada, 'YYYYMMDDHHmmss').startOf('day');
        if (fData < fDesde) {
          buscado = false;
        }
      }
      if (datos.idHastTemp != null) {
        const fHasta = dayjs(datos.idHastTemp).startOf('day');
        const fData = dayjs(listaActas[i].fechaNoModificada, 'YYYYMMDDHHmmss').startOf('day');
        if (fData > fHasta) {
          buscado = false;
        }
      }
      if (datos.idDes != null) {
        const folio = getFolioNumber(listaActas[i].Folio, PREFIX_VIA_PUBLICA);
        const folioDesde = getNumFromStr(datos.idDes);
        if (folioDesde != null && !Number.isNaN(folioDesde) && folio < folioDesde) {
          buscado = false;
        }
      }
      if (datos.idhats != null) {
        const folio = getFolioNumber(listaActas[i].Folio, PREFIX_VIA_PUBLICA);
        const folioHasta = getNumFromStr(datos.idhats);
        if (folioHasta != null && !Number.isNaN(folioHasta) && folio > folioHasta) {
          buscado = false;
        }
      }
      if (buscado) {
        filteredData.push(listaActas[i]);
      }
    }

    if (filteredData.length > 0) {
      setSearchValue('ji');
    } else {
      setSearchValue('lo');
    }
    const eNotificar = { target: { checked: false } };
    onCheckAllChange(eNotificar, 'Notificar');
    onCheckAllChange(eNotificar, 'Descargas');
    onCheckAllChange(eNotificar, 'Validar');
    setCheckedListDescargas([]);
    setUsuariosFiltro(filteredData);
  };

  const ValidarHallazgos = (flag) => {
    const peticion = {
      // token: '',
      hallazgos: {
        toDelete: [],
        toUpdate: [],
        toValidate: [],
        toDeValidate: [],
        toCancel: [],
        toSave: []
      }
    };

    // if (flag.target.checked === true) {
    try {
      let pkHallazgoV = 3;
      checkedListValidar.forEach((record) => {
        const update = {
          pkHallazgo: pkHallazgoV,
          idMonitoreo: record.idMonitoreo,
          idHallazgo: record.idHallazgo
        };
        peticion.hallazgos.toValidate.push(update);
        pkHallazgoV += 1;
      });
      listaValidarHllazgos.push(peticion);
    } catch (error) {
      console.log(error);
    }
  };

  const handleValidar = async () => {
    setLoadingBotton(true);
    setLoadingTable(true);
    code = '';
    if (checkedListValidar.length === 0) {
      messageApi.open({
        type: 'error',
        content: 'Debes seleccionar al menos un monitoreo para validar.'
      });
      return;
    }
    ValidarHallazgos(true);
    try {
      const results = await Promise.all(
        listaValidarHllazgos.map((x) => actasService.updateHallazgo(x))
      );
      code = results[0].status;
    } catch (error) {
      console.log(error);
    }
    listaDesvalidarHallazgos.forEach(async (x) => {
      try {
        const datos = await actasService.updateHallazgo(x);
        code = datos.status;
      } catch (error) {
        console.log(error);
      }
    });
    setTimeout(async () => {
      if (code === 200) {
        getActasEstatus();
        setTimeout(() => {
          setSearchValue('asa');
          const filltro = [];
          setUsuariosFiltro(filltro);
          // eslint-disable-next-line no-use-before-define
          dataProces();
        }, 3000);
        listaValidarHllazgos = [];
        listaDesvalidarHallazgos = [];
        setTimeout(() => {
          messageApi.open({
            type: 'success',
            content: 'Validado exitosamente'
          });
          setLoadingBotton(false);
          setLoadingTable(false);
        }, 3000);

        for (let i = 0; i < checkedListValidar.length; i++) {
          // MNI - Llamado a la generación de PDF's al momento de validar
          let monitoreoPDF = [
            {
              idMonitoreo: checkedListValidar[i].idMonitoreo,
              idTipoMonitoreo: 1,
              tiposActa: [{ id: 2, idsHallazgo: [checkedListValidar[i].idHallazgo] }]
            }
          ];

          // Se genera PDF una vez que se han almacenado las Muestras
          await generarPDFMonitoreosValidacion(monitoreoPDF);
        }
      } else {
        messageApi.open({
          type: 'error',
          content: 'No pudo ser validado'
        });
        setLoadingBotton(false);
        setLoadingTable(false);
      }
    }, 3000);
  };

  const handleConfirmCancel = async (comments) => {
    const payload = {
      hallazgos: {
        toCancel: [
          {
            pkHallazgo: monitoreoCancelar.idHallazgo,
            idHallazgo: monitoreoCancelar.idHallazgo,
            idMonitoreo: monitoreoCancelar.idMonitoreo,
            motivoCancelacion: comments.motivo
          }
        ]
      }
    };
    const { success, response } = await dispatch(cancelMonitoring(payload));
    if (success && response?.data.code === 200) {
      setMonitoreoCancelar(null);
      setSuccessCancelar(true);

      // MNI - Llamado a la generación de PDF's al momento de validar
      let monitoreoPDF = [
        {
          idMonitoreo: monitoreoCancelar.idMonitoreo,
          idTipoMonitoreo: 1,
          tiposActa: [{ id: 2, idsHallazgo: [monitoreoCancelar.idHallazgo] }]
        }
      ];

      // Se genera PDF una vez que se han almacenado las Muestras
      let generoPDF = await generarPDFMonitoreos(monitoreoPDF);
      if (generoPDF) {
        console.log('Se generó correctamente el PDF');
      } else {
        console.log('Error al generar el PDF');
      }

      getActas();
      // dispatch(getMonitoreosInternet(pagination.current, pagination.pageSize));
    } else if (response?.causa !== undefined) {
      messageApi.error(response.causa);
    } else {
      messageApi.error(MensGrales.MAV1_2);
    }
  };

  const handleCancelMonitoring = (cancelData) => {
    setMonitoreoCancelar(cancelData);
    setTitleCancel(
      <div>
        ¿Estás seguro de cancelar
        <br />
        el hallazgo {cancelData.Folio}?
      </div>
    );
  };

  const dataProces = () => {
    const datosActas = datosgetActa.data;
    const monitoreoData = datosActas.monitoreos;
    const newSeleccion = {};
    // eslint-disable-next-line func-names, array-callback-return
    const modifiedArr = monitoreoData.espectaculares.map(function (x) {
      monitoreo = {
        idAmbito: '',
        idEstado: '',
        idMonitoreo: '',
        idMunicipio: '',
        idProcesoElectoral: '',
        idProcesoEspecifico: '',
        hallazgo: [],
        notificacion: ''
      };
      monitoreo.idAmbito = x.idAmbito;
      monitoreo.idEstado = x.idEstado;
      monitoreo.estatus = x.estatus;
      monitoreo.nombreEstado = x.estado;
      monitoreo.notificacion = 'N/A';
      monitoreo.idMonitoreo = x.idMonitoreo;
      monitoreo.idMunicipio = x.idMunicipio;
      monitoreo.idProcesoElectoral = x.idProcesoElectoral;
      monitoreo.idProcesoEspecifico = x.idProcesoEspecifico;
      // eslint-disable-next-line array-callback-return
      x.hallazgos.map((z) => {
        hallazgo = {};
        hallazgo.key = uuid();
        hallazgo.cargos = cargos;
        hallazgo.ambitoMonitoreo = x.idAmbito;
        hallazgo.sujetosObligados = sujetosObligados;
        // Datos Hallazgo
        hallazgo.tipoMedida = z.tipoMedida;
        hallazgo.medida = z.medida;
        hallazgo.duracionHr = z.duracionHr;
        hallazgo.duracionMin = z.duracionMin;
        hallazgo.duracionSeg = z.duracionSeg;
        hallazgo.cantidad = z.cantidad;
        //
        hallazgo.catBeneficiado = catBeneficiado;
        hallazgo.idMonitoreo = x.idMonitoreo;
        hallazgo.idDistritoLoc = z.idDistritoLoc;
        hallazgo.idHallazgo = z.idHallazgo;
        hallazgo.idEntidad = x.idEstado;
        hallazgo.catMedidas = catUnidadesMedida;
        hallazgo.nombreEstado = x.estado;
        hallazgo.tipoBeneficio = z.tipoBeneficio;
        hallazgo.beneficiados = z.beneficiados;
        hallazgo.idTipoAsociacion = z.beneficiados[0]?.idTipoAsociacion;
        hallazgo.idSujetoObligado = z.beneficiados[0]?.idSujetoObligado;
        hallazgo.sujetoObligado = z.beneficiados[0]?.sujetoObligado;
        hallazgo.idContabilidad = z.beneficiados[0]?.idContabilidad;
        hallazgo.cargo = z.beneficiados[0]?.cargo;
        hallazgo.nombreBeneficiado = z.beneficiados[0]?.nombreBeneficiado;
        hallazgo.idBeneficiado = z.beneficiados[0]?.idBeneficiado;
        hallazgo.nombre = z.tipoBeneficio;
        hallazgo.idAmbito = z.idAmbito;
        hallazgo.idMunicipio = x.idMunicipio;
        hallazgo.idProcesoElectoral = z.idProcesoEspecifico;
        hallazgo.idINE = z.tipoBeneficio;
        hallazgo.ancho = z.tipoBeneficio;
        hallazgo.alto = z.tipoBeneficio;
        hallazgo.duracion = z.tipoBeneficio;
        hallazgo.lema = z.lema;
        hallazgo.infAdicional = z.infAdicional;
        hallazgo.Folio = z.folioMonitoreo;
        hallazgo.monitor = x.monitor;
        hallazgo.ubicacion = z.ubicacion;
        const time = z.fechaCreacion;
        hallazgo.fechaNoModificada = z.fechaCreacion;
        hallazgo.estados = catEstados;
        hallazgo.tipoAsociaciones = tipoAsociaciones;
        hallazgo.tipoBeneficios = tipoBeneficios;
        hallazgo.catProceso = catProceso;
        hallazgo.nombreProceso = x.procesoEspecifico;
        hallazgo.nombreAmbito = x.ambito;
        hallazgo.catMonitoreos = catMonitoreos;
        // eslint-disable-next-line vars-on-top
        var fecha = new Date(
          time.replace(/^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/, '$4:$5:$6 $2/$3/$1')
        );
        hallazgo.fechainicio = dayjs(fecha).locale('es').format('DD [de] MMMM [de] YYYY HH:mm');
        if (z.tipoHallazgo != null) {
          // eslint-disable-next-line array-callback-return
          cathallazgo.map((u) => {
            // eslint-disable-next-line eqeqeq
            if (u.idCHallazgo == z.tipoHallazgo) {
              hallazgo.tipoHallazgo = u.hallazgo;
            }
          });
        }
        hallazgo.idTipoHallazgo = z.tipoHallazgo;
        if (z.tipoBeneficio != null) {
          // eslint-disable-next-line array-callback-return
          tipoBeneficios.map((b) => {
            // eslint-disable-next-line eqeqeq
            if (b.idTipoBeneficio == z.tipoBeneficio) {
              hallazgo.tipoBeneficio = b.nombreTipoBeneficio;
            }
          });
        }
        hallazgo.cathallazgo = cathallazgo;
        hallazgo.idTipoBeneficcio = z.tipoBeneficio;
        hallazgo.estatus = z.estatus;
        hallazgo.notificacion = 'N/A';
        if (z.estatus === 2) {
          hallazgo.estatus = 'No validado';
          hallazgo.boolEstatus = false;
        }
        if (z.estatus === 3) {
          hallazgo.estatus = 'Cancelado';
          hallazgo.boolEstatus = false;
        }
        if (z.estatus === 4) {
          hallazgo.estatus = 'Validado';
          hallazgo.boolEstatus = true;
        }
        hallazgo.idestatus = z.estatus;
        monitoreo.hallazgo.push(hallazgo);
      });
      monitoreos.push(monitoreo);
    });
    listaActas = [];
    if (monitoreos.length > 0) {
      const ListaActas = monitoreos.map((x) => {
        // eslint-disable-next-line array-callback-return
        x.hallazgo.map((y) => {
          listaActas.push(y);
        });
        return listaActas;
      });
      processRangeCheckValidar(0, pagination.pageSize - 1, ListaActas);
    }
    setCheckedListValidar([]);
    setSearchValue('');
  };

  const FilterIdActa = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span className="tituloTable">ID de hallazgo</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={listaActas === null || listaActas.length === 0}
            onChange={(e) => {
              setSearchValue('');
              const currValue = e.target.value;
              const copiaUsr = [...listaActas];
              if (currValue.length > 0 && copiaUsr.length > 0) {
                setSearchValue(currValue);
                const filteredData = copiaUsr.filter((entry) =>
                  entry.idHallazgo.toString().includes(currValue)
                );
                setUsuariosFiltro(filteredData);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );
  const FilterIdMonitoreo = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span className="tituloTable">Folio de monitoreo</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Form.Item name="folio">
            <Input
              placeholder="Filtra"
              disabled={listaActas === null || listaActas.length === 0}
              onChange={handleChangeFolioFilter}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
  const FilterMonitor = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span className="tituloTable2">Monitorista</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={listaActas === null || listaActas.length === 0}
            allowClear
            onChange={(e) => {
              setSearchValue('');
              const currValue = e.target.value;
              const copiaUsr = [...listaActas];
              if (currValue.length > 0 && copiaUsr.length > 0) {
                setSearchValue(currValue);
                const filteredData = copiaUsr.filter(
                  (entry) =>
                    entry.monitor.includes(currValue) ||
                    entry.monitor.toLowerCase().includes(currValue) ||
                    entry.monitor.toUpperCase().includes(currValue) ||
                    removeAccents(entry.monitor.toUpperCase()).includes(currValue) ||
                    removeAccents(entry.monitor.toLowerCase()).includes(currValue) ||
                    removeAccents(
                      entry.monitor.charAt(0).toUpperCase() + entry.monitor.slice(1)
                    ).includes(currValue)
                );
                setUsuariosFiltro(filteredData);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );
  const FilterByFecha = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span className="tituloTable">Fecha</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Space direction="vertical">
            <DatePicker
              disabled={listaActas === null || listaActas.length === 0}
              locale={locale}
              onChange={(dateValue, dateString) => {
                setSearchValue('');
                const copiaUsr = [...listaActas];
                if (dateString.length > 0 && copiaUsr.length > 0) {
                  setSearchValue(dateString);
                  const filteredData = copiaUsr.filter((entry) => {
                    const fFilter = dateValue.startOf('day');
                    const fData = dayjs(entry.fechaNoModificada, 'YYYYMMDDHHmmss').startOf('day');
                    return fFilter.isSame(fData);
                  });
                  setUsuariosFiltro(filteredData);
                }
              }}
              placement={placement}
              placeholder=""
              format={dateFormat}
            />
          </Space>
        </Col>
      </Row>
    </>
  );
  const FilterHallazgo = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span className="tituloTable">Tipo de hallazgo</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={listaActas === null || listaActas.length === 0}
            onChange={(e) => {
              setSearchValue('');
              const currValue = e.target.value;
              const copiaUsr = [...listaActas];
              if (currValue.length > 0 && copiaUsr.length > 0) {
                setSearchValue(currValue);
                const filteredData = copiaUsr.filter((entry) =>
                  removeAccents(entry.tipoHallazgo.toString().toLowerCase()).includes(
                    removeAccents(currValue.toLowerCase())
                  )
                );
                setUsuariosFiltro(filteredData);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );
  const FilterBeneficio = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span className="tituloTable">Tipo de beneficio</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={listaActas === null || listaActas.length === 0}
            onChange={(e) => {
              setSearchValue('');
              const currValue = e.target.value;
              const copiaUsr = [...listaActas];
              if (currValue.length > 0 && copiaUsr.length > 0) {
                setSearchValue(currValue);
                const filteredData = copiaUsr.filter((entry) =>
                  removeAccents(entry.tipoBeneficio.toString().toLowerCase()).includes(
                    removeAccents(currValue.toLowerCase())
                  )
                );
                setUsuariosFiltro(filteredData);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );
  const FilterEstatus = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span className="tituloTable2">Estatus</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={listaActas === null || listaActas.length === 0}
            onChange={(e) => {
              setSearchValue('');
              const currValue = e.target.value;
              const copiaUsr = [...listaActas];
              if (currValue.length > 0 && copiaUsr.length > 0) {
                setSearchValue(currValue);
                const filteredData = copiaUsr.filter((entry) =>
                  removeAccents(entry.estatus.toString().toLowerCase()).includes(
                    removeAccents(currValue.toLowerCase())
                  )
                );
                setUsuariosFiltro(filteredData);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );

  const FilterEstado = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span className="tituloTable2">Entidad</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Select
            style={{ width: '100%' }}
            fieldNames={{ value: 'id', label: 'nombre' }}
            optionFilterProp="children"
            placeholder="Filtra"
            allowClear
            disabled={listaActas === null || listaActas.length === 0}
            options={catEstadosFilter}
            onChange={(e) => {
              setSearchValue('');
              const currValue = e;
              const copiaUsr = [...listaActas];
              if (currValue > 0 && copiaUsr.length > 0) {
                setSearchValue(currValue);
                const filteredData = copiaUsr.filter((entry) => entry.idEntidad === currValue);
                setUsuariosFiltro(filteredData);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );

  const handleDownloadExcel = async () => {
    setDownloadingExcel(true);
    const { success, response } = await dispatch(
      downloadExcelHallazgos({ tipoMonitoreo: MONITOREOS_ESPECTACULARES })
    );
    if (response !== null && response !== undefined && success) {
      if (response.data.code === 200) {
        if (response.data.excel64) {
          const url = window.URL.createObjectURL(
            base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.excel64.nombre);
          link.click();
          setDownloadingExcel(false);
        }
      }
    }
    setDownloadingExcel(false);
  };

  const renderAcccions = (record) => {
    return (
      <div className="column-acciones">
        <Tooltip
          title="Consultar"
          className="tooltip-acciones btn-deleteoutlined"
          placement="topLeft"
          arrow={{ pointAtCenter: true }}>
          <Button
            shape="circle"
            onClick={() => {
              messageApi.open({
                content: <Spin />
              });
              const { idMonitoreo, idHallazgo } = record;
              handleGetPdfActa(idHallazgo, 'eyeOutlined', idMonitoreo);
            }}
            icon={<EyeOutlined className="icons-tbl-users" />}
          />
        </Tooltip>
        {((getMenuPermissions(
          menu,
          NOMBRE_MENU_ESPECTACULARES,
          NOMBRE_SUBMENU_ACTAS_HALLAZGOS,
          NOMBRE_MENU_PERMISO_EDITAR
        ) &&
          record.idestatus === 2) ||
          tienePermisoEditar) && (
          <Tooltip
            title="Editar"
            className="tooltip-acciones btn-deleteoutlined"
            placement="topLeft"
            arrow={{ pointAtCenter: true }}>
            <Button
              shape="circle"
              onClick={() => {
                setIsModalOpen(true);
                actaSeleccionar(record.idHallazgo);
              }}
              icon={<EditOutlined className="icons-tbl-users" />}
            />
          </Tooltip>
        )}
        <Tooltip
          title="Descargar"
          className="tooltip-acciones btn-downloadoutlined"
          placement="topLeft"
          arrow={{ pointAtCenter: true }}>
          <Button
            shape="circle"
            onClick={() => {
              messageApi.open({
                content: <Spin />
              });
              const { idMonitoreo, idHallazgo } = record;
              handleGetPdfActa(idHallazgo, 'downloadOutlined', idMonitoreo);
            }}
            icon={<DownloadOutlined className="icons-tbl-users" />}
          />
        </Tooltip>
        {((getMenuPermissions(
          menu,
          NOMBRE_MENU_ESPECTACULARES,
          NOMBRE_SUBMENU_ACTAS_HALLAZGOS,
          NOMBRE_MENU_PERMISO_ELIMINAR
        ) &&
          record.idestatus === 2) ||
          (tienePermisoEditar && record.idestatus !== 3)) && (
          <Tooltip
            title="Cancelar"
            className="tooltip-acciones btn-deleteoutlined"
            placement="topLeft"
            arrow={{ pointAtCenter: true }}>
            <Button
              shape="circle"
              icon={<CloseCircleOutlined className="icons-tbl-users" />}
              onClick={() => {
                setIsModalCancel(true);
                handleCancelMonitoring(record);
              }}
            />
          </Tooltip>
        )}
      </div>
    );
  };

  const columns = [
    {
      title: FilterIdMonitoreo,
      dataIndex: 'Folio',
      key: 'Folio',
      width: '9%'
    },
    {
      title: FilterIdActa,
      dataIndex: 'idHallazgo',
      width: '8%',
      key: 'idHallazgo'
    },
    {
      title: FilterMonitor,
      dataIndex: 'monitor',
      width: '11%',
      key: 'monitor'
    },
    {
      title: FilterEstado,
      dataIndex: 'nombreEstado',
      width: '9%',
      key: 'nombreEstado'
    },
    {
      title: FilterHallazgo,
      dataIndex: 'tipoHallazgo',
      width: '9%',
      key: 'tipoHallazgo'
    },
    {
      title: FilterBeneficio,
      dataIndex: 'tipoBeneficio',
      key: 'tipoBeneficio',
      width: '9%'
    },
    {
      title: FilterByFecha,
      dataIndex: 'fechainicio',
      width: '13%',
      key: 'fechainicio'
    },
    {
      title: FilterEstatus,
      dataIndex: 'estatus',
      key: 'estatus',
      width: '7%'
    },
    {
      title: checkAllValidar('validacion', 'Check de validación'),
      key: 'validacion',
      width: '5%',
      align: 'center',
      render: (_, record) => renderCheck(record, data.rol)
    },
    {
      title: checkAllNotificar('aNotificar', 'Notificar a partido'),
      key: 'aNotificar',
      width: '5%',
      align: 'center',
      render: (_, row) => renderCheckboxNotificar(row)
    },
    {
      title: checkAll('descarga', 'Check de descarga'),
      key: 'descarga',
      width: '5%',
      align: 'center',
      render: (_, row) => renderCheckboxDescarga(row)
    },
    {
      title: 'Acciones',
      key: 'acciones',
      width: '10%',
      align: 'center',
      render: (_, record) => renderAcccions(record)
    }
  ];

  const allowedColumns = () => {
    if (
      !getMenuPermissions(
        menu,
        NOMBRE_MENU_ESPECTACULARES,
        NOMBRE_SUBMENU_ACTAS_HALLAZGOS,
        NOMBRE_MENU_PERMISO_NOTIFICAR
      )
    ) {
      return columns
        .map((column) =>
          column.key.includes('aNotificar') || column.key.includes('validacion') ? null : column
        )
        .filter((column) => column !== null);
    }
    return columns;
  };

  const onClickButtonNotificarOGenerar = () => {
    notificadosParcialmente.forEach((item) => {
      notificar.current[item.idHallazgo] = true;
    });
    // console.log('notificar', notificar, notificadosParcialmente);
  };

  useEffect(() => {
    if (checkedListNotificar?.length === 0 || notificadosParcialmente?.length === 0) {
      setDisableButtonNotificar(true);
    }
    if (checkedListNotificar?.length > 0 || notificadosParcialmente?.length > 0) {
      setDisableButtonNotificar(false);
    }
  }, [checkedListNotificar, checkedListValidar]);

  return (
    <div className="seccion-lo">
      <Row>
        <Col span={18}>
          <HeaderPage
            section="Monitoreos"
            section2="Espectaculares"
            title="Hallazgos"
            header="Selecciona al menos un campo para realizar la búsqueda."
          />
        </Col>
      </Row>
      <Row>
        <Col span={4} className="margen-bilateral">
          <h4>Proceso Electoral:</h4>
        </Col>
        <Col span={4} className="margen-bilateral">
          <h4>Proceso específico:</h4>
        </Col>
        <Col span={7} className="margen-bilateral">
          <h4>Fecha:</h4>
        </Col>
        <Col span={3} className="margen-bilateral">
          <h4>Folio del monitoreo:</h4>
        </Col>
      </Row>
      <Form name="form-user" layout="vertical" onFinish={busqueda} form={form}>
        <Row>
          <Col span={4} className="margen-bilateral">
            <Form.Item name="proceso">
              <Select
                placeholder="Filtra &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                allowClear
                options={catProceso}
                fieldNames={{ value: 'idProcesoElectoral', label: 'descripcion' }}
              />
            </Form.Item>
          </Col>
          <Col span={3} className="margen-bilateral">
            <Form.Item name="procesoEsp">
              <Select
                placeholder="Filtra &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                allowClear>
                <Option value="1">Precampaña</Option>
                <Option value="2">Campaña</Option>
                <Option value="3">Intercampaña</Option>
                <Option value="4">Apoyo Ciudadano</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={1} className="margen-bilateral paddingTop5 textoDerecha">
            <span>Desde:</span>
          </Col>
          <Col span={3} className="margen-bilateral">
            <Form.Item name="idDesTemp">
              <DatePicker
                disabled={listaActas === null || listaActas.length === 0}
                locale={locale}
                onChange={(_e, dateString) => {
                  setSearchValue('');
                  const currValue = dateString;
                }}
                placement={placement}
                placeholder=""
                format={dateFormat}
                minDate={dayjs(fechaIniciOper, dateFormatFiltro)}
                maxDate={dayjs(fechaHoy, dateFormatFiltro)}
              />
            </Form.Item>
          </Col>
          <Col span={1} className="margen-bilateral paddingTop5 textoDerecha">
            <span>Hasta:</span>
          </Col>
          <Col span={3} className="margen-bilateral">
            <Form.Item name="idHastTemp">
              <DatePicker
                disabled={listaActas === null || listaActas.length === 0}
                locale={locale}
                onChange={(_e, dateString) => {
                  setSearchValue('');
                  const currValue = dateString;
                }}
                placement={placement}
                placeholder=""
                format={dateFormat}
                minDate={dayjs(fechaIniciOper, dateFormatFiltro)}
                maxDate={dayjs(fechaHoy, dateFormatFiltro)}
              />
            </Form.Item>
          </Col>
          <Col span={2} className="margen-bilateral paddingTop5 textoDerecha">
            <span>Desde: INE-VP-</span>
          </Col>
          <Col span={2} className="margen-bilateral">
            <Form.Item name="idDes">
              <Input />
            </Form.Item>
          </Col>
          <Col span={2} className="margen-bilateral paddingTop5 textoDerecha">
            <span>Hasta: INE-VP-</span>
          </Col>
          <Col span={2} className="margen-bilateral">
            <Form.Item name="idhats">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={10}>&nbsp;</Col>
          <Col span={2}>
            <Button
              type="default"
              text="Limpiar"
              onClick={() => {
                form.resetFields();
                limpiar();
              }}
            />
          </Col>
          <Col span={2}>
            <Form.Item>
              <Button type="primary" htmlType="submit" text="Buscar" />
            </Form.Item>
          </Col>
        </Row>
        <div className="div-header-table">
          <div>
            <SelectTamanoPagina
              value={pagination.pageSize}
              onChange={handleChangePageSize}
              disableBottomExcel={downloadingExcel}
              onClick={handleDownloadExcel}
            />
          </div>
        </div>
        {contextHolder}
        <Table
          bordered={false}
          columns={allowedColumns()}
          scroll={{ x: 'max-content' }}
          loading={loading}
          dataSource={searchValue === '' ? listaActas : usuariosFiltro}
          pagination={{
            ...pagination,
            total: totalRegistros,
            current: pagination.current,
            onChange: (page, pageSize) => {
              setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize: pageSize
              }));
              setLoading(true);
              processRangeCheckNotificar(
                page,
                pageSize,
                searchValue === '' ? listaActas : usuariosFiltro
              );
              processRangeCheckValidar(
                page,
                pageSize,
                searchValue === '' ? listaActas : usuariosFiltro
              );
              // getActas();
            }
          }}
        />
      </Form>
      <div className="contenedorBtns">
        {getMenuPermissions(
          menu,
          NOMBRE_MENU_ESPECTACULARES,
          NOMBRE_SUBMENU_ACTAS_HALLAZGOS,
          NOMBRE_MENU_PERMISO_NOTIFICAR
        ) && (
          <>
            <div className="btnNotificar">
              <Button
                onClick={() => {
                  onClickButtonNotificarOGenerar();
                  setVisibleModalNotificar(true);
                }}
                size="large"
                type="primary"
                text="Enviar notificación"
                icon={<BellOutlined />}
                disabled={disableButtonNotificar || loading}
              />
            </div>
            {/* <div className="btnGenerar">
              <DescripcionEnlacesModal
                seleccion={notificar}
                tipoMonitoreo={MONITOREOS_ESPECTACULARES}
                tipoActa={ACTA_HALLAZGO}
                disabledButton={disableButtonNotificar}
              />
            </div> */}
          </>
        )}
        <div className="btnValidar">
          {tienePermisoValidar && (
            <Button
              type="primary"
              size="large"
              loading={loading}
              text="Validar monitoreos"
              disabled={disableBtnVali}
              onClick={handleValidar}
            />
          )}
        </div>
      </div>
      <ModalNotificarPartido
        visible={visibleModalNotificar}
        seleccion={notificar}
        tipo={TIPO_HALLAZGO}
        onClose={() => setVisibleModalNotificar(false)}
        getMonitoreos={getActas}
      />
      <ModalActa
        name="modal-hallazgo"
        open={isModalOpen}
        callback={() => {
          setIsModalOpen(false);
        }}
        dataActa={datosActa}
        call={() => {
          setLoading(true);
          getActas();
        }}
        renderBeneficiados={getRandomInt(100)}
        setIsVisibleSuccessModal={setIsVisibleSuccessModal}
      />
      <InfoModal
        visible={isVisibleSuccessModal}
        description="Registro modificado exitosamente"
        onClose={() => {
          setIsVisibleSuccessModal(false);
        }}
      />
      <ModalPdf
        open={isModalPdfOpen}
        pdfActa={pdfActa}
        tipoActa={ACTA_HALLAZGO}
        callback={() => setIsModalPdfOpen(false)}
        idActa={isHallazgoId}
        idMonitoreo={isMonitoreoId}
        destroyOnClose
      />
      {/* <ModalPdf open={isModalPDF} callback={() => setIsModalPDF(false)} dataActa={dataActa} /> */}
      <div>
        <CancelModalMonitoring
          open={monitoreoCancelar}
          title={titleCancel}
          cancelConfirm={handleConfirmCancel}
          handleCerrar={() => {
            setMonitoreoCancelar(null);
            setSuccessCancelar(false);
          }}
          openSuccess={successCancelar}
          msgSuccess="El hallazgo se canceló con éxito."
        />
      </div>
      <SelectorTipoDescarga
        seleccion={seleccion}
        tipoMonitoreo={MONITOREOS_ESPECTACULARES}
        tipoActa={ACTA_HALLAZGO}
        procesarTodo={procesarTodo}
      />
    </div>
  );
}

export default Monitoreo;
